import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { NgForOf } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { MissingInputError } from '@shared/errors/missing-input/missing-input.error';
import { RECIPE_TRANSLATION_ICONS_PATH } from '@shared/constants/icons-paths.constant';

@Component({
  selector: 'app-recipes-translation-variants',
  templateUrl: './recipes-translation-variants.component.html',
  styleUrls: ['./recipes-translation-variants.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, NgForOf, TranslateModule],
})
export class RecipesTranslationVariantsComponent implements OnInit {
  @Input() variants: string[];

  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly domSanitizer = inject(DomSanitizer);

  constructor() {
    this.loadSvgIcons();
  }

  ngOnInit(): void {
    if (!this.variants) {
      throw new MissingInputError('variants');
    }
  }

  private loadSvgIcons(): void {
    this.matIconRegistry.addSvgIcon(
      'ic_chef',
      this.domSanitizer.bypassSecurityTrustResourceUrl(`../../../../${RECIPE_TRANSLATION_ICONS_PATH}/ic_chef.svg`),
    );
  }
}
